<template>
    <!-- <my-dialog
      @hideMask="hideMask"
      :dialogFlag="showChooseDialog"
      width="852px"
      p_lr="32px 36px 16px"
      :clickMaskForHide="true"
    > -->
      <div class="switching_mechanism" @mousedown="e => e.preventDefault()">
        <div class="lists">
          <!-- 省份列表 -->
          <div class="list_item">
            <div class="list_header">
              <a-checkbox :checked="provinceIsAllSelectStatus" :indeterminate="provinceIsSomeSelect" @change="provinceIsAllSelect"> 省份 </a-checkbox>
              <span>{{ provinceSelectList.length || 0 }}/{{ provinceList.length || 0 }}</span>
            </div>
            <div class="list_search">
              <a-input placeholder="请输入省份" v-model="provinceSubmit" @pressEnter="searchProvinceList">
                <template #prefix>
                  <span @click="searchProvinceList">
                    <img src="~@/assets/img/search.png" alt="">
                  </span>
                </template>
              </a-input>
            </div>
            <div class="item_body">
              <div v-for="item in provinceList" :key="item.provinceId">
                <a-checkbox :checked="provinceSelectList.includes(item.provinceId)" :disabled="item.schoolCount == 0" @change="e => selectProvince(e, item)">{{ item.provinceName }}</a-checkbox>
              </div>
            </div>
          </div>
          <!-- 机构学校列表 -->
          <div class="list_item" style="margin-left: 13px">
            <div class="list_header">
              <!-- <a-checkbox :checked="schoolIsAllSelectStatus" :indeterminate="schoolIsSomeSelect" @change="schoolIsAllSelect"> 机构 </a-checkbox> -->
              <span>机构</span>
              <span>{{ schoolSelectList.length || 0 }}/{{ schoolList.length || 0 }}</span>
            </div>
            <div class="list_search">
              <a-input placeholder="请输入学校名" v-model="schoolSubmit" @pressEnter="searchSchoolList">
                <template #prefix>
                  <span @click="searchSchoolList"><img src="~@/assets/img/search.png" alt=""></span>
                </template>
              </a-input>
            </div>
            <div class="item_body">
              <!-- <div v-for="item in schoolList" :key="item.id">
                <a-checkbox :checked="schoolSelectList.includes(item.id)"  @change="e => selectSchool(e, item)">{{ item.schoolName }}</a-checkbox>
              </div> -->
                <a-radio-group v-model="selectSchool" @change="handleSelectSchool">
                  <a-radio :style="radioStyle" v-for="item in schoolList" :key="item.id" :value="item.schoolCode" :checked="selectSchool == item.schoolCode">
                    {{ item.schoolName }}
                  </a-radio>
                </a-radio-group>
            </div>
          </div>
        </div>
      </div>
    <!-- </my-dialog> -->
</template>

<script>
export default {
    props: {
        provinceList: {
            type: Array,
        },
        initSelectSchool: {
            type: Number,
        }
    },
    watch: {
        initSelectSchool: {
            handler: function(val) {
                if (val) {
                   this.selectSchool = val 
                }
            },
            immediate: true 
        }
    },
   data() {
    return {
        provinceIsAllSelectStatus: false,
        provinceIsSomeSelect: false,
        provinceSelectList: [], // 选中省份列表
        provinceSubmit: '', // 搜索省份名字
        schoolList: [], // 学校机构列表
        schoolSelectList: [], // 选中学校列表
        selectSchool: '',
        selectSchoolName: '',
        schoolSubmit: '', // 搜索学校名字
        radioStyle: {
          display: 'block',
          height: '40px',
          lineHeight: '40px',
        },
    }
   },
   mounted() {
        this.searchProvinceList()
   },
   methods: {
    provinceIsAllSelect(e) {
      if (e.target.checked) {
        this.provinceIsAllSelectStatus = true
        this.provinceSelectList = this.provinceCanSelectList
      } else {
        this.provinceIsAllSelectStatus = false
        this.provinceSelectList = []
      }
      this.provinceIsSomeSelect = false
      if (this.provinceSelectList.length) {
        this.searchSchoolList()
      } else {
        this.schoolList = []
        this.currentSelectSchoolList = []
        this.schoolSelectList = []
        // this.schoolIsAllSelectStatus = false
        // this.schoolIsSomeSelect = false
      }
    },
    searchProvinceList() {
      this.provinceCanSelectList = (this.provinceList || []).filter(item => item.schoolCount != 0).map(item => item.provinceId)
      let provinceTList = (this.provinceList || []).map(item => item.provinceId)
      this.searchSchoolList(false, provinceTList)
    },
    selectProvince(e, item) {
      if (this.provinceSelectList.includes(item.provinceId)) {
        let provinceSet = new Set(this.provinceSelectList)
        provinceSet.delete(item.provinceId)
        this.provinceSelectList = Array.from(provinceSet)
        // 取消省份选中 删除选中学校机构
        let schoolListT = this.currentSelectSchoolList.filter(item1 => item1.provinceId != item.provinceId) || []
        this.currentSelectSchoolList = schoolListT
        let schoolListT2 = (this.schoolList.filter(item1 => item1.provinceId == item.provinceId) || []).map(item1 => item1.id)
        this.schoolSelectList = this.schoolSelectList.filter(item1 => !schoolListT2.includes(item1))
        this.updateSchoolSelectStatus()
      } else {
        this.provinceSelectList.push(item.provinceId)
      }
      if (this.provinceSelectList.length == 0) {
        this.schoolList = []
      } else {
        this.searchSchoolList()
      }
      this.updateProvinceSelectStatus()
    },
    schoolIsAllSelect(e) {
      if (e.target.checked) {
        this.schoolSelectList = this.schoolList.map(item => item.id)
        this.currentSelectSchoolList = this.schoolList
      } else {
        this.schoolSelectList = []
        this.currentSelectSchoolList = []
      }
      this.updateSchoolSelectStatus()
    },
    async searchSchoolList(isSelect = false, list = []) {
      let provinceIds = ''
      if (list.length) {
        provinceIds = list.join(',')
      } else {
        provinceIds = this.provinceSelectList.join(',')
      }
      let res = await this.$http.batchSchoolByProvinceId({
        provinceIds,
        schoolName: this.schoolSubmit
      })
      if (res.code !== 200) return this.$message.error(res.msg)
      this.schoolList = res.rt || []
      this.updateSchoolSelectStatus()
      if (isSelect) {
        this.schoolSelectList = this.currentSelectSchoolList.map(item => item.id)
        this.updateSchoolSelectStatus()
      }
    },
    handleSelectSchool(e) {
        console.log('e---', e);
        this.selectSchoolName = this.schoolList.find(item => item.schoolCode == e.target.value).schoolName
        this.selectSchool = e.target.value
        console.log(':schoolItem:>>>>', this.selectSchool, this.selectSchoolName);
        this.handleCurrentSchool()
        this.updateSchoolSelectStatus()
    },
    handleCurrentSchool() {
        this.$emit('saveCurrentSchool', this.selectSchool, this.selectSchoolName)
    },
    /**
     * @description: 更新管理学校机构列表选中状态
     * @param {*}
     * @return {*}
     */
    updateSchoolSelectStatus() {
    //   if (this.schoolSelectList.length != this.schoolList.length) {
    //     if (this.schoolSelectList.length == 0) {
    //     //   this.schoolIsSomeSelect = false
    //     //   this.schoolIsAllSelectStatus = false
    //     } else {
    //       this.schoolIsSomeSelect = true
    //     //   this.schoolIsAllSelectStatus = false
    //     }
    //   } else {
    //     if (this.schoolSelectList.length == 0) {
    //       this.schoolIsSomeSelect = false
    //     //   this.schoolIsAllSelectStatus = false
    //     } else {
    //       this.schoolIsSomeSelect = false
    //     //   this.schoolIsAllSelectStatus = true
    //     }
    //   }
    },
    /**
     * @description: 更新省份全选信息
     * @param {*}
     * @return {*}
     */
    updateProvinceSelectStatus() {
      if (this.provinceSelectList.length != this.provinceCanSelectList.length) {
        if (this.provinceSelectList.length == 0) {
          this.provinceIsSomeSelect = false
          this.provinceIsAllSelectStatus = false
        } else {
          this.provinceIsSomeSelect = true
          this.provinceIsAllSelectStatus = false
        }
      } else {
        this.provinceIsSomeSelect = false
        this.provinceIsAllSelectStatus = true
      }
    },
   }
}
</script>

<style lang="scss" scoped>
.switching_mechanism {
    background: #fff;
  .lists {
    display: flex;
    .list_item {
      border-radius: 4px;
      border: 1px solid #f6f8fa;
      width: 240px;
      height: 472px;
      .list_header {
        display: flex;
        justify-content: space-between;
        padding: 11px 12px;
        background: #f6f8fa;
        > span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9ca5b1;
        }
        > span:nth-child(1) {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #041633;
        }
       ::v-deep.ant-checkbox-wrapper {
          > span:nth-child(2) {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #041633;
          }
        }
       ::v-deep.ant-checkbox-checked {
          .ant-checkbox-inner {
            background-color: #5f60d3;
            border-color: transparent;
          }
        }
       ::v-deep.ant-checkbox-indeterminate {
          .ant-checkbox-inner {
            &::after {
              background-color: #5f60d3;
            }
          }
        }
      }
      .list_search {
        border-bottom: 1px solid #F6F8FA;
        >span {
          width: 223px;
          margin-top: 8px;
          margin-bottom: 8px;
          ::v-deep.ant-input {
            border-radius: 19px !important;
            border: 1px solid #E3E8EC;
          }
          padding: 0 8px;
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
      .item_body {
        text-align: left;
        height: 380px;
        overflow-y: scroll;
        >div {
          padding: 11px 12px;
         ::v-deep.ant-checkbox-checked {
            .ant-checkbox-inner {
              background-color: #5f60d3;
              border-color: transparent;
            }
          }
        }
      }
      .select_item_body {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #041633;
        >div {
          display: flex;
          justify-content: space-between;
          img {
            width: 16px;
            height: 16px;
            margin-top: 3px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>